<template>
  <div class="xiaorder-continner">
    <div class="header-title">下单中心</div>
    <div class="sub-continner">
      <!-- <van-field
        readonly
        clickable
        name="picker"
        :value="value"
        label="类型"
        placeholder="全部"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="timeValue"
        label="时间范围"
        placeholder="默认显示全部"
        @click="showCalendar = true"
      />
      <van-calendar
        v-model="showCalendar"
        type="range"
        :min-date="minDate"
        @confirm="onCalConfirm"
      /> -->
      <!-- <div class="person-card-content-second">
        <div
          id="allo"
          class="item-second-content selected"
          @click="queryOrderWithStatus('全部'); changeSeletorStyle($event)"
        >
          {{ orderTypeNumbers.total || 0}}
          <div>全部</div>
        </div>
        <div class="line-area"></div>
        <div
          id="readyoo"
          class="item-second-content"
          @click="queryOrderWithStatus('已下单'); changeSeletorStyle($event)"
        >
          {{ orderTypeNumbers.readyOrderNumber || 0}}
           <div>已下单</div>
        </div>
        <div class="line-area"></div>
        <div
          id="longtimeo"
          class="item-second-content"
          @click="queryOrderWithStatus('超时发货')"
          style="color: #fff;"
        >
          {{ orderTypeNumbers.waitSendOrderNumber || 0}}
          <div>待发货</div>
        </div>
        <div class="line-area"></div>
        <div
          id="sureviewo"
          class="item-second-content"
          @click="queryOrderWithStatus('超时发货'); changeSeletorStyle($event)"
        >
          {{ orderTypeNumbers.waitAppealOrderNumber || 0}}
          <div>待申诉</div>
        </div>
        <div class="line-area"></div>
        <div
          id="backmoneyo"
          class="item-second-content"
          @click="queryOrderWithStatus('已退款'); changeSeletorStyle($event)"
        >
          {{ orderTypeNumbers.payForOrderNumber || 0}}
          <div>已赔付</div>
        </div>
      </div> -->
      <div class="person-card-content-second"></div>
      <div class="main-card">
        <div class="main-card-content">
          提示：选择要下的订单，点立即下单，然后选
          <div>中下单用的账号点击确定即可！</div>
        </div>
      </div>

      <div class="main-list" ref="scrollArea">
        <!--<div class="main-list-opertion">
          <van-button
            type="info"
            size="small"
            style="margin-bottom: 5px;margin-right: 10px;"
            @click="batchOperation"
          >
            批量操作
          </van-button>
        </div>-->
        <!-- <van-checkbox-group v-model="checkboxGroup" ref="checkboxGroup"> -->
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <van-cell
              v-for="item in dataList"
              :key="item.orderId"
              :title="item.title"
              :label="item.label"
              @click="changeRentNumStatus(item)"
            >
              <template #title>
                <span
                  >订单编号： <span>{{ item.orderNumbers }}</span></span
                >
              </template>
              <template #default>
                <div
                  style="display: flex;flex-direction: row;justify-content: flex-end;align-items: center;"
                >
                  本金：<span
                    style="font-size:xx-small;color: red; margin-right: 10px;"
                    >{{ item.orderMoney }}</span
                  >
                  佣金：<span
                    style="font-size:xx-small;color: red;padding-right: 5px;"
                    >{{ item.commission }}</span
                  >
                  <!-- <van-checkbox
                      v-if="item.statusStr == '准备中'"
                      :name="item"
                      @click.stop.native="() => {}"
                    ></van-checkbox> -->
                </div>
              </template>
              <template #label>
                <div
                  style="display: flex;align-items: center;white-space: nowrap;overflow: hidden;"
                >
                  <span style="flex-shrink: 0;">下单状态：</span
                  ><span
                    style="color: red;min-width: 0;overflow: hidden;text-overflow: ellipsis;"
                    >{{ item.statusStr }}</span
                  ><span
                    style="flex-shrink: 0;padding-left: 10px;color: cornflowerblue;font-size: 12px !important;"
                    >点击下单</span
                  >
                </div>
              </template>
            </van-cell>
          </van-list>
        <!-- </van-pull-refresh> -->
        <!-- </van-checkbox-group> -->
      </div>
      <!-- <div class="operation-bottom-area" v-show="isHaveOrderReady">
        <div class="operation-item-one">
          <van-button @click="batchOperation">批量下单</van-button>
        </div>
        <div class="operation-item-two">
          <van-checkbox v-model="checked" @change="chooseAndProcess"
            >全选</van-checkbox
          >
        </div>
      </div> -->
    </div>
    <van-popup v-model="showDialogPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="rentNumbers"
        value-key="rentNumbers"
        @confirm="onConDialogfirm"
        @cancel="showDialogPicker = false"
      />
    </van-popup>

    <van-dialog v-model="reciveOrderShow" :show-confirm-button="false">
      <template #title>
        <div
          style="text-align: right;color: #f55033;line-height: 24px;padding-right: 10px;"
        >
          <div @click="reciveOrderShow = false" v-show="showX">X</div>
        </div>
      </template>
      <div style="max-height: 320px;overflow-y: scroll;" ref="scroll">
        <van-steps direction="vertical" :active="tmpAction">
          <van-step v-for="item in stepsInfo" :key="item.id">
            <div
              :style="
                tmpAction != item.id ? { color: 'gray' } : { color: '#07c160' }
              "
            >
              【{{ item.status }}】[{{ item.uuid }}]{{ item.message
              }}<span style="padding-left: 5px;">{{ item.stepTime }}</span>
            </div>
          </van-step>
        </van-steps>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  getAdminOrderVoList,
  setRejectOrderShop,
  queryOrderNumberWithStatus,
  batchReciveOrders,
} from "../../api/system/mobile_taskorder";
import { queryUserRentnumbers } from "../../api/system/sys_plateform";
import { Toast, Dialog } from "vant";
import { guid } from "../../lib/utils";
import DateFromate from "dateformat-util";
export default {
  name: "xiaorder",
  data() {
    return {
      queryForm: {},
      value: "",
      minDate: new Date(2025, 0, 1),
      columns: [
        "全部",
        "准备中",
        "待发货",
        "超时发货",
        "申诉中",
        "申诉完成",
        "退款中",
        "已退款(完成)",
      ],
      showPicker: false,
      showCalendar: false,
      showDialogPicker: false,
      timeValue: "",
      refreshing: false,
      loading: false,
      finished: false,
      rentNumbers: [],
      requestData: {},
      dataList: [],
      reciveOrderShow: false,
      tmpAction: 0,
      stepsInfo: [],
      tmpTimer: null,
      checkboxGroup: [],
      checked: false,
      showX: false,
      orderTypeNumbers: {},
      pagination: {
        pageNum: 0,
        pageSize: 20,
        total: null,
      },
    };
  },
  computed: {
    isHaveOrderReady() {
      return this.dataList.some((item) => {
        return item.statusStr == "准备中";
      });
    },
  },
  mounted() {
    this.$emit("titleChange", "下单");
    this.calcScrollHeight();
    window.addEventListener("resize", this.calcScrollHeight);
    queryUserRentnumbers({ rentStatus: 3 }, { pageNum: 1, pageSize: 20 }).then(
      (res) => {
        if (res.success) {
          this.rentNumbers = res.data.records;
        }
      },
    );

    //this.stepsAction();
    queryOrderNumberWithStatus().then((res) => {
      if (res.success) {
        console.log("+++++++11111+++++", res.data);
        this.orderTypeNumbers = res.data;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcScrollHeight);
  },
  methods: {
    calcScrollHeight() {
      const el = this.$refs.scrollArea;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const tabbarH = 50;
      const safeBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue("env(safe-area-inset-bottom)")) || 0;
      el.style.height = (window.innerHeight - rect.top - tabbarH - safeBottom) + "px";
    },
    chooseAndProcess() {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll();
      }
      //console.log(this.checkboxGroup);
    },
    scrollBottom() {
      var div = this.$refs.scroll;
      div.scrollTop = div.scrollHeight;
    },
    stepsAction() {
      console.log("stepsAction", this.requestData);
      this.stepsInfo = [];
      clearTimeout(this.tmpTimer);
      this.tmpTimer = null;
      this.showX = false;
      this.reciveOrderShow = true;

      let steps = [
        {
          id: 0,
          status: "登陆账号",
          message: "正在获取账号信息",
        },
        {
          id: 1,
          status: "登陆账号",
          message: "正在核对账号密码",
        },
        {
          id: 2,
          status: "登陆账号",
          message: "正在远程登陆账号",
        },
        {
          id: 3,
          status: "登陆账号",
          message: "登陆成功",
        },
        {
          id: 4,
          status: "下单中",
          message: "账号正常开始接受任务",
        },
        {
          id: 5,
          status: "下单中",
          message: "模拟搜索翻页",
        },
        {
          id: 6,
          status: "下单中",
          message: "浏览宝贝",
        },
        {
          id: 7,
          status: "下单中",
          message: "浏览店铺",
        },
        {
          id: 8,
          status: "下单中",
          message: "选中商品",
        },
        {
          id: 9,
          status: "下单中",
          message: "收藏宝贝",
        },
        {
          id: 10,
          status: "下单中",
          message: "正在更换收货地址",
        },
        {
          id: 11,
          status: "下单中",
          message: `${this.requestData.orderMoney}元转入平台总账户`,
        },
        {
          id: 12,
          status: "下单中",
          message: "正在请求平台总账户代付",
        },
        {
          id: 13,
          status: "下单中",
          message: "平台AI企业支付宝正在代付",
        },
        {
          id: 14,
          status: "订单完成",
          message: "付款成功",
        },
      ];

      // 每条消息各自的停留时长（毫秒）：
      // 登号 id0-4 与搜索 id5 每条 6-7 秒，浏览 id6-10 每条 5 秒，转账付款 id11-13 每条 8 秒
      let durations = steps.map((step) => {
        if (step.id <= 5) return 6000 + Math.random() * 1000;
        if (step.id <= 10) return 5000;
        if (step.id <= 13) return 8000;
        // 「付款成功」是最后一条，后面没有等待
        return 0;
      });

      let i = 0;
      let uuid = guid();

      const pushNextStep = () => {
        let stepsTmp = steps[i];
        stepsTmp.uuid = uuid;
        stepsTmp.stepTime = DateFromate.format(
          new Date(),
          "yyyy-MM-dd hh:mm:ss",
        );
        this.stepsInfo.push(stepsTmp);
        this.tmpAction = stepsTmp.id;
        // 当前这条消息停留的时间，就是下一条消息出现前等待的时间
        let wait = durations[i];
        i++;
        this.$nextTick(() => {
          this.scrollBottom();
        });
        if (i >= steps.length) {
          this.tmpTimer = null;
          this.showX = true;
          return;
        }
        this.tmpTimer = setTimeout(pushNextStep, wait);
      };

      pushNextStep();

      //console.log(this.stepsInfo);
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
      this.showPicker = false;
      this.queryForm.startTime = "";
      this.queryForm.endTime = "";
      this.getData();
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onCalConfirm(date) {
      let [start, end] = date;
      this.timeValue = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      this.showCalendar = false;
      this.queryForm.startTime = this.formatDate(start);
      this.queryForm.endTime = this.formatDate(end);
      this.getData();
    },
    changeSeletorStyle(e) {
      //console.log(e)
      document
        .querySelectorAll(".item-second-content")
        .forEach((el) => el.classList.remove("selected"));
      e.currentTarget.classList.toggle("selected");
    },
    queryOrderWithStatus(status) {
      this.value = status;
      this.getData();
      // this.$nextTick(() => {
      //   // 确保 DOM 已经更新
      //   this.changeSeletorStyle(status);
      // });
    },
    getData() {
      let tmpStatus = 202305250003;
      switch (this.value) {
        case "准备中":
          tmpStatus = 202305250003;
          break;
        case "待发货":
          tmpStatus = 202305250002;
          break;
        // case "复活":
        //   tmpStatus = 202109020001;
        //   break;
        case "超时发货":
          tmpStatus = 202211240001;
          break;
        case "申诉中":
          tmpStatus = 202109010001;
          break;
        case "申诉完成":
          //这个地方有两种处理方式， 1，申诉成功，发起退款。 2，申诉失败，订单完成。
          tmpStatus = 202109010002;
          break;
        case "退款中":
          tmpStatus = 202109020002;
          break;
        case "已退款":
          tmpStatus = 202205090001;
          break;
        case "已完成":
          tmpStatus = 202109030004;
          break;
        default:
          tmpStatus = null;
      }
      this.queryForm.status = tmpStatus;
      // 重置分页状态，确保从第一页开始加载
      this.pagination.pageNum = 1;
      this.finished = false;
      this.dataList = [];
      this.loading = true;

      getAdminOrderVoList(this.queryForm, this.pagination)
        .then((res) => {
          if (res.success) {
            console.log(res.data);
            this.dataList = res.data.records;
          }
        })
        .catch((err) => {
          Toast.fail(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onLoad() {
      // if (this.refreshing) {
      //   this.refreshing = false;
      // }
      if (this.finished) {return;}
      else this.pagination.pageNum = this.pagination.pageNum + 1;

      this.loading = true;

      getAdminOrderVoList(this.queryForm, this.pagination)
        .then((res) => {
          if (res.success) {
            console.log(res.data);
            if (res.data.records.length > 0) {
              this.dataList.push(...res.data.records);
            }
            this.orderTypeNumbers.total = res.data.total;
            if (this.dataList.length >= res.data.total) {
              this.finished = true;
            }
          }
        })
        .catch((err) => {
          Toast.fail(err.message);
        })
        .finally(() => {
          this.loading = false;
          this.$nextTick(() => this.calcScrollHeight());
        });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      if (!this.finished) {
        this.pagination.pageNum = this.pagination.pageNum + 1;
      }
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    batchOperation() {
      //console.log(this.checkboxGroup, this.orderTypeNumbers);
      batchReciveOrders(this.buildOrderListInfo(this.checkboxGroup))
        .then((res) => {
          this.stepsAction();
          if (res.success) {
            this.getData();
          }
          this.reciveOrderShow = true;
        })
        .catch((err) => {
          Toast.fail(err.message);
        });
    },
    changeRentNumStatus(orderItem) {
      //console.log(orderItem);
      if (this.getStatusWithStatusVal(orderItem.status) == "准备中") {
        Dialog.confirm({
          title: "确认下单",
          message: `请确认要下单当前订单吗？`,
        })
          .then(() => {
            //update rentnumbers
            queryUserRentnumbers(
              { rentStatus: 3 },
              { pageNum: 1, pageSize: 20 },
            ).then((res) => {
              if (res.success) {
                this.rentNumbers = res.data.records;
                // on confirm
                this.showDialogPicker = true;
                this.requestData = orderItem;
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        Dialog.confirm({
          title: "提示",
          message: `当前订单<span style="color:red;">${orderItem.orderNumbers}</span>操作无权限! 若已下单，请在<span style="color:red;">《订单》</span>中操作。`,
        })
          .then(() => {
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    getStatusWithStatusVal(status) {
      switch (status) {
        case "202305250003":
          return "准备中";
        case "202305250002":
          return "待发货";
        // case "202109020001":
        //   return "复活";
        case "202109030004":
          return "已完成";
      }
    },
    queryNextStatus(status) {
      switch (status) {
        case "202305250003":
          return "待发货";
        // case "202305250002":
        //   return "复活";
        case "202109020001":
          return "已完成";
      }
    },
    buildOrderListInfo(orderList) {
      let orderListInfo = [];
      orderList.forEach((item) => {
        let orderInfo = {};
        orderInfo.isReciveOrder = true;
        orderInfo.b2cOrderId = item.orderId;
        orderInfo.b2cPlateformAccountId = item.plateformAccountId;
        orderListInfo.push(orderInfo);
      });
      return orderListInfo;
    },
    onConDialogfirm(val) {
      //console.log(val)
      //console.log(this.requestData)
      let orderInfo = {};
      orderInfo.isReciveOrder = true;
      orderInfo.b2cOrderId = this.requestData.orderId;
      orderInfo.b2cPlateformAccountId = val.id;
      this.showDialogPicker = false;
      setRejectOrderShop(orderInfo)
        .then((res) => {
          this.stepsAction();
          if (res.success) {
            //console.log(res.data)
            this.getData();
          }
          this.reciveOrderShow = true;
        })
        .catch((err) => {
          Toast.fail(err.message);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../root.scss";
.xiaorder-continner {
  background-color: rgb(249, 249, 249);
  background-image: url(../../assets/img/thembg.png);
  background-repeat: no-repeat;
  background-size: contain;
  height: 100dvh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sub-continner {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

::v-deep .van-dialog__header {
  padding-top: 0px;
}

.van-cell span {
  font-size: calculeResultFontSize(false, 2px) !important;
}

.item-second-content {
  color: #ffffff;
}

.selected {
  color: #f55033;
}
</style>
